import { render, staticRenderFns } from "./PsiDetailRegisterInfo.vue?vue&type=template&id=195e622b"
import script from "./PsiDetailRegisterInfo.vue?vue&type=script&lang=js"
export * from "./PsiDetailRegisterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports